/* global require */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.


/* @REFACTOR: esse arquivo esta sendo usado por muito anos de forma diferente, tem codigo de todos os tipos e misturado
 o ideal e atualizar para tudo funcionar da mesma forma */

require('@rails/ujs').start();
require('@rails/activestorage').start();
import "./channels/**/*_channel.js";
require("chartkick/chart.js");

// Start Turbo
import { Turbo } from "@hotwired/turbo-rails";
Turbo.start();

import './modal-alert';
import './help';

import "flowbite/dist/flowbite.turbo.js";
import { initFlowbite } from 'flowbite';

function initAvatarDropdown() {
    const userMenuButton = document.querySelector('#user-menu-button, [data-dropdown-toggle="dropdown-user"]');
    if (userMenuButton) {
        initFlowbite();
        return true;
    } else {
        return false;
    }
}

document.addEventListener('turbo:frame-render', () => {
    
    setTimeout(() => {
        if (initAvatarDropdown()) {
        } else {
        }
    }, 1000);
});

document.addEventListener('turbo:frame-load', () => {
    setTimeout(() => {
        if (initAvatarDropdown()) {
        } else {
        }
    }, 1200);
});

// I18n Javascript support

import { I18n } from 'i18n-js';
window.I18n = I18n;

// ApexCharts

import ApexCharts from 'apexcharts'
window.ApexCharts = ApexCharts

HTMLElement.prototype.appendNewChild = function (tagName, attributes = {}, content = null) {
    let newElem = document.createElement(tagName);

    for (let attrName in attributes) {
        if (attributes.hasOwnProperty(attrName)) {
            newElem.setAttribute(attrName, attributes[attrName]);
        }
    }

    if (content) {
        newElem.innerHTML = content;
    }

    this.appendChild(newElem);
    return newElem;
};

HTMLElement.prototype.raiseEvent = function (eventName, data = null, bubbles = true, cancelable = true, composed = false) {
    let event = new CustomEvent(eventName, { detail: data, cancelable: cancelable, bubbles: bubbles, composed: composed });
    this.dispatchEvent(event);
};

function systemMessage(message, kind = 'danger') {
    let btn = document.getElementById('system-messages')
        .appendNewChild('div', { class: `alert alert-${kind}` }, message)
        .appendNewChild('button', { type: 'button', class: 'close' });
    btn.appendNewChild('span', null, '×');
    btn.dataset.dismiss = 'alert';
}

window.alert = systemMessage;

import Shortcut from './shortcuts';

document.addEventListener('turbo:load', () => {
    Shortcut.start();
    
    // Controle global da navbar e layout para monitoring/map
    const navbar = document.querySelector('nav');
    const mainContainer = document.querySelector('div.flex.flex-start');
    const sidebar = document.querySelector('#drawer-navigation');
    
    if (window.location.pathname.includes('/monitoring/map')) {
        // Esconder navbar
        if (navbar) navbar.style.display = 'none';
        // Remover pt-16 do container principal
        if (mainContainer) {
            mainContainer.classList.remove('pt-16');
        }
        // Remover padding do sidebar
        if (sidebar) {
            sidebar.className = sidebar.className.replace(/pt-\d+/, 'pt-0');
        }
    } else {
        // Mostrar navbar
        if (navbar) navbar.style.display = '';
        // Adicionar pt-16 de volta ao container principal
        if (mainContainer) {
            mainContainer.classList.add('pt-16');
        }
        // Restaurar padding do sidebar
        if (sidebar) {
            sidebar.className = sidebar.className.replace(/pt-\d+/, 'pt-16');
        }
    }
});

// Controlar navbar em mudanças de turbo frame
document.addEventListener('turbo:frame-load', () => {
    const navbar = document.querySelector('nav');
    const mainContainer = document.querySelector('div.flex.flex-start');
    const sidebar = document.querySelector('#drawer-navigation');
    
    if (window.location.pathname.includes('/monitoring/map')) {
        // Esconder navbar
        if (navbar) navbar.style.display = 'none';
        // Remover pt-16 do container principal
        if (mainContainer) {
            mainContainer.classList.remove('pt-16');
        }
        // Remover padding do sidebar
        if (sidebar) {
            sidebar.className = sidebar.className.replace(/pt-\d+/, 'pt-0');
        }
    } else {
        // Mostrar navbar
        if (navbar) navbar.style.display = '';
        // Adicionar pt-16 de volta ao container principal
        if (mainContainer) {
            mainContainer.classList.add('pt-16');
        }
        // Restaurar padding do sidebar
        if (sidebar) {
            sidebar.className = sidebar.className.replace(/pt-\d+/, 'pt-16');
        }
    }
});

import "trix"
import "@rails/actiontext"